import { Component } from 'react';
import {
    Box,
    Grid,
    Typography,
} from '@mui/material';

class RuleDisplay extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rule: props.ruleParameters.rule,
            ruleId: props.ruleParameters.ruleId,
            groupSize: props.ruleParameters.groupSize,
            raceCount: props.ruleParameters.raceCount,
            playerCount: props.ruleParameters.playerCount,
        };
    }

    componentDidUpdate(prevProps) {
        // Check if ruleParameters prop has changed
        if (prevProps.ruleParameters !== this.props.ruleParameters) {
            this.setState({
                rule: this.props.ruleParameters.rule,
                ruleId: this.props.ruleParameters.ruleId,
                groupSize: this.props.ruleParameters.groupSize,
                raceCount: this.props.ruleParameters.raceCount,
                playerCount: this.props.ruleParameters.playerCount,
            });
        }
    }

    render() {
        return (
            <Box component="main" sx={{ width: '90%', fontSize: '0.8rem', p: 1 }}>
                {/* Row for the Rule */}
                <Grid container spacing={2} sx={{ mb: 2 }}>
                    <Grid item xs={12} textAlign="center">
                        <Typography variant="body2">
                            <span style={{ fontWeight: 'bold' }}>Rule:</span> {this.state.rule}
                        </Typography>
                    </Grid>
                </Grid>

                <Grid container spacing={2}>
                    <Grid item xs={4} textAlign="center">
                        <Typography variant="body3" fontWeight="bold" display="block">
                            Group Size
                        </Typography>
                        <Typography variant="body3" display="block">
                            {this.state.groupSize}
                        </Typography>
                    </Grid>
                    <Grid item xs={4} textAlign="center">
                        <Typography variant="body3" fontWeight="bold" display="block">
                            Total Races
                        </Typography>
                        <Typography variant="body3" display="block">
                            {this.state.raceCount}
                        </Typography>
                    </Grid>
                    <Grid item xs={4} textAlign="center">
                        <Typography variant="body3" fontWeight="bold" display="block">
                            Total Players
                        </Typography>
                        <Typography variant="body3" display="block">
                            {this.state.playerCount}
                        </Typography>
                    </Grid>
                </Grid>
            </Box>
        );
    }
}

export default RuleDisplay;
